<script setup lang="ts">
defineOptions({
	name: 'IconSadFace',
})

interface Props {
	class?: string
	classIcon?: string
}

const props = withDefaults(defineProps<Props>(), {
	class: 'text-neutral-50',
	classIcon: 'w-8 h-8',
})
</script>

<template>
	<svg
		xmlns="http://www.w3.org/2000/svg"
		:class="[props.class, props.classIcon]"
		viewBox="0 0 31 31"
		fill="none"
	>
		<path
			d="M23.5427 8.00403C27.9361 12.3974 27.9361 19.5205 23.5427 23.9139C19.1493 28.3073 12.0262 28.3073 7.63279 23.9139C3.23939 19.5205 3.23939 12.3974 7.63279 8.00403C12.0262 3.61063 19.1493 3.61063 23.5427 8.00403"
			stroke="currentColor"
			stroke-width="1.91884"
			stroke-linecap="round"
			stroke-linejoin="round"
		/>
		<path
			d="M11.6502 12.3965L10.7752 13.2715"
			stroke="currentColor"
			stroke-width="1.91884"
			stroke-linecap="round"
			stroke-linejoin="round"
		/>
		<path
			d="M19.5251 12.3965L20.4001 13.2715"
			stroke="currentColor"
			stroke-width="1.91884"
			stroke-linecap="round"
			stroke-linejoin="round"
		/>
		<path
			d="M11.2126 20.9588C11.2126 20.9588 12.8539 19.3188 15.5876 19.3188C18.3226 19.3188 19.9626 20.9588 19.9626 20.9588"
			stroke="currentColor"
			stroke-width="1.91884"
			stroke-linecap="round"
			stroke-linejoin="round"
		/>
	</svg>
</template>
